export const MARKER_IDS = {
  GREY: "grey-arrow-marker",
  PINK: "pink-arrow-marker", // Level 0
  PURPLE: "purple-arrow-marker", // Level 1
  BLUE: "blue-arrow-marker", // Level 2
  GREEN: "green-arrow-marker", // Level 3
  AMBER: "amber-arrow-marker", // Level 4
  SELECTED: "selected-arrow-marker",
} as const;
